import React from 'react'

import cashEventImage from '@assets/images/cashflow_event_image.png'

import { BackToDashboardButton } from '../../Components/BackToDashboardButton'
import { RefreshButton } from '../../Components/RefreshButton'

export const Show = () => {
  return (
    <div className='astute-request-wrapper'>
      <h1>Contacting Astute</h1>
      <p className='astute-request-wrapper--subheading'>
        Sending paper planes to Astute...
      </p>
      <img
        src={cashEventImage}
        alt='astute pending graphic'
        className='astute-request-wrapper--graphic'
      />
      <p className='astute-request-wrapper--link-text'>
        We're connecting with Astute on your behalf. You can check back here later for updates.
      </p>
      <div className='astute-back-to-dashboard'>
        <BackToDashboardButton />
        <div className='refresh-button-wrapper'>
          <RefreshButton />
        </div>
      </div>
    </div>
  )
}
